//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum CatalogType {
	Product = 0,
	Service = 1,
	Contract = 2,
	PrepaidService = 3
}
